import React from 'react';
import AppBreadcrumbs from '../../components/AppBreadcrumbs';
import { withRouter } from 'react-router';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Tooltip from '@material-ui/core/Tooltip';
import Redirect from '../../helpers/Redirect';
import Alert from '@material-ui/lab/Alert';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import AccessibilityIcon from '@material-ui/icons/Accessibility';
import Icon from '@material-ui/core/Icon';
import Env from '../../config/env';
import Api from '../../helpers/Api';
import Session from '../../helpers/Session';
import GetDataApi from '../../helpers/GetDataApi';
import Grid from '@material-ui/core/Grid';
import AppInputText from '../../ui/AppInputText';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import AppToast from '../../ui/AppToast';
import IconButton from '@material-ui/core/IconButton';
import RespuestaSolicitud from './RespuestaSolicitud';
import MensajeGestor from './MensajeGestor';
import { confirmAlert } from 'react-confirm-alert';
import StoreTemp from '../../store/store_temp';

const initialForm = {
  radicado: {
    key: 'radicado',
    value: '',
    required: false,
  },
  nombreProyecto: {
    key: 'nombreProyecto',
    value: '',
    required: false,
  },
  estado: {
    key: 'estado',
    value: '',
    required: false,
  },
};

class CuentaNuevaList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form: initialForm,
      url: '',
      openDialog: false,
      openDialogRespuestas: false,
      openDialogConfirmar: false,
      openDialogMensajeGestor: false,
      solicitudID: null,
      loadData: {
        estados: [],
      },
      data: [],
      userLogued: null,
      solicitudSelected: null,
    };
  }

  async componentDidMount() {
    this.loadControls();
    this.buscar();
    this.setState({
      userLogued: Session.getLogin(),
    });
  }

  loadControls = async () => {
    const response = await Api.get(`${Env.UrlBackendCuentaNueva}/solicitud/load-controls-list`);
    if (response.success) {
      this.setState({
        loadData: {
          ...this.state.loadData,
          estados: response.data.estados,
        },
      });
    } else {
      AppToast(response.message, false);
    }
  };

  handleChange = async (e) => {
    const { value, name } = e.target;

    this.setState((statePrev) => {
      return {
        form: {
          ...statePrev.form,
          [name]: {
            ...statePrev.form[name],
            value: value,
          },
        },
      };
    });
  };

  buscar = async (page = 1, add = false) => {
    const user = Session.getLogin();

    let params = GetDataApi(this.state.form);
    params = {
      ...params,
      numero_documento: user.terceroDocumento,
      correo_electronico: user.terceroMail,
    };

    const jsonParams = JSON.stringify(params);
    const response = await Api.get(`${Env.UrlBackendCuentaNueva}/solicitud/get-by-user?params=${jsonParams}&page=${page}`);

    this.setState((prevState) => ({
      data: add ? [...(prevState.data || []), ...response.data] : response.data,
      total: response.total,
      last_page: response.last_page,
      next_page: response.next_page,
    }));
  };

  limpiar = () => {
    this.setState(
      {
        form: initialForm,
      },
      () => {
        this.buscar();
      },
    );
  };

  handleOpenDialog = () => {
    this.setState({
      openDialog: true,
    });
  };

  handleCloseDialog = () => {
    this.setState({
      openDialog: false,
    });
  };

  openCuentaNuevaForm = (tipoUsuario) => {
    this.setState({
      url: `/new-account/${tipoUsuario}`,
    });
  };

  openDocumentacionForm = (solicitud) => {
    this.setState({
      url: `/new-account/documentation/${solicitud.id}`,
    });
  };

  handleOpenDialogRespuestas = (value) => {
    this.setState({
      openDialogRespuestas: true,
      solicitudID: value.id,
      solicitudSelected: value,
    });
  };

  handleCloseDialogRespuestas = () => {
    this.setState({
      openDialogRespuestas: false,
    });
  };

  handleOpenDialogMensajeGestor = (val) => {
    this.setState({
      openDialogMensajeGestor: true,
      solicitudSelected: val,
    });
  };

  handleCloseDialogMensajeGestor = () => {
    this.setState({
      openDialogMensajeGestor: false,
    });
  };

  handleOpenDialogConfirmar = (val) => {
    this.setState({
      openDialogConfirmar: true,
      solicitudSelected: val,
    });
  };

  handleCloseDialogConfirmar = () => {
    this.setState({
      openDialogConfirmar: false,
    });
  };

  async confirmarSolicitud() {
    const params = {
      solicitudID: this.state.solicitudSelected?.id,
    };
    const data = await Api.post(`${Env.UrlBackendCuentaNueva}/solicitud/confirmar-electricista`, params);
    if (data.success) {
      AppToast(data.message, true);
      this.buscar();
      this.handleCloseDialogConfirmar();
    } else {
      AppToast(data.message, false);
    }
  }

  async rechazarSolicitud() {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h3>
              ¿Está seguro(a) de rechazar la solicitud? <br /> Esta acción no se puede reversar.
            </h3>
            <button onClick={onClose}>No</button>
            <button
              className="custom-ui-btn-si"
              onClick={async () => {
                const params = {
                  solicitudID: this.state.solicitudSelected?.id,
                  solicitudPasoID: this.state.solicitudSelected?.solicitud_paso_id,
                };
                const data = await Api.post(`${Env.UrlBackendCuentaNueva}/solicitud/rechazar-electricista`, params);
                if (data.success) {
                  AppToast(data.message, true);
                  this.buscar();
                  this.handleCloseDialogConfirmar();
                } else {
                  AppToast(data.message, false);
                }

                onClose();
              }}
            >
              Si
            </button>
          </div>
        );
      },
    });
  }

  async cargarMas(nextPage) {
    this.buscar(nextPage, true);
  }

  handleEditFormulario = (val) => {
    if (val.tipo.codigo === 'AGD') {
      const newWindow = window.open(`${Env.app_new_account}/solicitud/autogeneracion-gd/${val.id}`, '_blank');
      const session = localStorage.getItem('session');
      const sendData = () => {
        if (newWindow) {
          newWindow.postMessage({ session }, Env.app_new_account);
        }
      };
      setTimeout(sendData, 1000);
    } else {
      StoreTemp.set('solicitud', val);
      if (val.tipousuario === 'propietario') {
        this.openCuentaNuevaForm(Env.tipoUsuario.propietario);
      } else {
        this.openCuentaNuevaForm(Env.tipoUsuario.electricista);
      }
    }
  };

  render() {
    return (
      <div style={{ minHeight: '500px', textAlign: 'center' }}>
        <Redirect url={this.state.url} />

        <AppBreadcrumbs
          links={[
            {
              url: 'accounts',
              label: 'Cuentas',
            },
          ]}
          actual="Listado de cuentas nuevas"
        />

        <h2>
          <span>Listado de cuentas nuevas</span>
        </h2>

        <div style={{ textAlign: 'center', paddingLeft: '30px', paddingRight: '30px' }}>
          <fieldset style={{ marginBottom: '20px', padding: '10px' }}>
            <legend style={{ textAlign: 'left' }}>Parámetros de búsqueda</legend>

            <Grid container justify="center" spacing={1}>
              <Grid item xs={2}>
                <AppInputText
                  id={this.state.form.radicado.key}
                  name={this.state.form.radicado.key}
                  value={this.state.form.radicado.value}
                  required={this.state.form.radicado.required}
                  label="Radicado"
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={3}>
                <AppInputText
                  id={this.state.form.nombreProyecto.key}
                  name={this.state.form.nombreProyecto.key}
                  value={this.state.form.nombreProyecto.value}
                  required={this.state.form.nombreProyecto.required}
                  label="Nombre del proyecto"
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={3}>
                <FormControl variant="outlined" style={{ width: '100%' }}>
                  <InputLabel id="demo-simple-select-outlined-label">Estado</InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id={this.state.form.estado.key}
                    name={this.state.form.estado.key}
                    value={this.state.form.estado.value}
                    onChange={this.handleChange}
                    label="Estado"
                    variant="outlined"
                  >
                    {this.state.loadData.estados.map((val, index) => {
                      return (
                        <MenuItem key={index} value={val.id}>
                          {val.nombre}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container justify="center">
              <Grid item>
                <Button variant="contained" color="primary" size="large" startIcon={<Icon>search</Icon>} style={{ margin: '10px' }} onClick={this.buscar}>
                  Buscar
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  startIcon={<Icon>cleaning_services</Icon>}
                  style={{ margin: '10px' }}
                  onClick={this.limpiar}
                >
                  Limpiar
                </Button>
              </Grid>
            </Grid>
          </fieldset>

          {this.state.data.length === 0 ? (
            <Alert severity="info">¡No se encontraron registros!</Alert>
          ) : (
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '20px 0' }}>
                <div>
                  <b>Total de registros:</b> {this.state.total || 0} &nbsp;|&nbsp;
                  <b>Total de páginas:</b> {this.state.last_page || 1} &nbsp;|&nbsp;
                  <b>Página actual:</b> {this.state.next_page > 0 ? this.state.next_page - 1 : 1}
                </div>
                {this.state.next_page > 0 && (
                  <Button variant="contained" color="primary" onClick={() => this.cargarMas(this.state.next_page)} disabled={!this.state.data}>
                    Cargar más
                  </Button>
                )}
              </div>

              <table className="custom-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th style={{ width: '10%' }}>Radicado</th>
                    <th style={{ width: '12%' }}>Radicado Salida</th>
                    <th>Nombre proyecto</th>
                    <th>Tipo</th>
                    <th>Zona</th>
                    <th>Municipio</th>
                    <th>Dirección</th>
                    <th>Propietario</th>
                    <th>Electricista</th>
                    <th style={{ width: '13%' }}>Fecha Confirmación Electricista</th>
                    <th>Estado</th>
                    <th colSpan={4}>Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.data.map((val, index) => {
                    return (
                      <tr key={index}>
                        <td>{val.rn}</td>
                        <td>{val?.radicado}</td>
                        <td>
                          <Tooltip title={val?.radicado_salida}>
                            <span>{val?.radicado_salida}</span>
                          </Tooltip>
                        </td>
                        <td>{val?.nombre_proyecto}</td>
                        <td>{val?.tipo?.nombre}</td>
                        <td>{val?.zona?.nombre}</td>
                        <td>{val?.municipio?.nombre}</td>
                        <td>{val?.direccion}</td>
                        <td>
                          {val?.usuario?.primer_nombre} {val?.usuario?.segundo_nombre} {val?.usuario?.primer_apellido} {val?.usuario?.segundo_apellido}
                        </td>
                        <td>
                          {val?.electricista?.primer_nombre} {val?.electricista?.segundo_nombre} {val?.electricista?.primer_apellido}{' '}
                          {val?.electricista?.segundo_apellido}
                        </td>

                        {val?.fecha_confi_elect ? (
                          // Si tiene fecha de confirmación
                          <td>{val?.fecha_confi_elect}</td>
                        ) : (
                          // Si NO tiene fecha de confirmación
                          <td>
                            {
                              // Valida que el estado sea: Pendiente Confirmación
                              val?.estado?.codigo === 'PC' ? (
                                <>
                                  <span
                                    style={{
                                      background: '#E37222',
                                      color: 'white',
                                      padding: '10px',
                                      borderRadius: '10px',
                                    }}
                                  >
                                    Sin Confirmar
                                  </span>

                                  {
                                    // Si el usuario logueado es el electricista, habilita el boton para confirmar
                                    this.state.userLogued.terceroDocumento === val?.electricista?.numero_documento ? (
                                      <Tooltip title="Confirmar">
                                        <IconButton
                                          style={{ color: '#4caf50' }}
                                          onClick={() => {
                                            this.handleOpenDialogConfirmar(val);
                                          }}
                                        >
                                          <Icon>check_circle</Icon>
                                        </IconButton>
                                      </Tooltip>
                                    ) : null
                                  }
                                </>
                              ) : (
                                <span
                                  style={{
                                    background: '#e57373',
                                    color: 'white',
                                    padding: '10px',
                                    borderRadius: '10px',
                                  }}
                                >
                                  --- Cancelado ---
                                </span>
                              )
                            }
                          </td>
                        )}

                        <td>{val?.estado?.nombre}</td>

                        <td>
                          {val?.solicitud_paso?.estado?.codigo === 'PD' ? (
                            <Tooltip title="Adjuntar Documentación">
                              <IconButton
                                color="secondary"
                                onClick={() => {
                                  this.openDocumentacionForm(val);
                                }}
                              >
                                <Icon>attachment</Icon>
                              </IconButton>
                            </Tooltip>
                          ) : null}
                        </td>

                        <td>
                          {val?.estado?.codigo === 'S' || val?.estado?.codigo === 'PGU' ? (
                            <Tooltip title="Enviar mensaje al gestor">
                              <IconButton
                                color="secondary"
                                onClick={() => {
                                  this.handleOpenDialogMensajeGestor(val);
                                }}
                              >
                                <Icon>mark_email_read</Icon>
                              </IconButton>
                            </Tooltip>
                          ) : null}
                        </td>

                        <td>
                          <Tooltip title="Ver Gestión">
                            <IconButton
                              color="secondary"
                              onClick={() => {
                                this.handleOpenDialogRespuestas(val);
                              }}
                            >
                              <Icon>speaker_notes</Icon>
                            </IconButton>
                          </Tooltip>
                        </td>

                        <td>
                          {val?.isedit === '1' ? (
                            <Tooltip title="Editar Formulario">
                              <IconButton
                                color="secondary"
                                onClick={() => {
                                  this.handleEditFormulario(val);
                                }}
                              >
                                <Icon>edit</Icon>
                              </IconButton>
                            </Tooltip>
                          ) : null}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <Tooltip title="Radicar una cuenta nueva">
          <Fab onClick={this.handleOpenDialog} color="primary" aria-label="add" className="float-button">
            <AddIcon />
          </Fab>
        </Tooltip>

        <Dialog onClose={this.handleCloseDialog} aria-labelledby="customized-dialog-title" open={this.state.openDialog}>
          <DialogContent style={{ padding: '0px' }}>
            <h3 style={{ textAlign: 'center' }}>Por favor seleccione el tipo de usuario.</h3>

            <div style={{ width: '400px' }}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                startIcon={<AccessibilityIcon />}
                style={{ margin: '10px' }}
                onClick={() => {
                  this.openCuentaNuevaForm(Env.tipoUsuario.propietario);
                }}
              >
                Propietario
              </Button>

              <Button
                variant="contained"
                color="secondary"
                size="large"
                startIcon={<Icon>engineering</Icon>}
                style={{ margin: '10px' }}
                onClick={() => {
                  this.openCuentaNuevaForm(Env.tipoUsuario.electricista);
                }}
              >
                Electricista
              </Button>
            </div>
            <h3 style={{ textAlign: 'center' }}>Radicar una solicitud tipo:</h3>
            <div style={{ width: '400px', alignContent: 'center', display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                style={{ margin: '10px' }}
                onClick={() => {
                  const newWindow = window.open(`${Env.app_new_account}/solicitud/autogeneracion-gd`, '_blank');
                  const session = localStorage.getItem('session');
                  const sendData = () => {
                    if (newWindow) {
                      newWindow.postMessage({ session }, Env.app_new_account);
                    }
                  };
                  setTimeout(sendData, 1000);
                }}
              >
                AUTOGENERACIÓN Y GENERACIÓN DISTRIBUIDA
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        <Dialog fullScreen open={this.state.openDialogRespuestas} onClose={this.handleCloseDialogRespuestas}>
          <RespuestaSolicitud onClose={this.handleCloseDialogRespuestas} solicitud={this.state.solicitudSelected} solicitudID={this.state.solicitudID} />
        </Dialog>

        <Dialog onClose={this.handleCloseDialogMensajeGestor} aria-labelledby="customized-dialog-title" open={this.state.openDialogMensajeGestor}>
          <MensajeGestor onClose={this.handleCloseDialogMensajeGestor} solicitud={this.state.solicitudSelected} />
        </Dialog>

        <Dialog onClose={this.handleCloseDialogConfirmar} aria-labelledby="customized-dialog-title" open={this.state.openDialogConfirmar}>
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <h3>
              Confirmar la solicitud con radicado: <span style={{ color: '#0098DB' }}> {this.state.solicitudSelected?.radicado} </span>
            </h3>

            <div style={{ textAlign: 'left' }}>
              <p>* Usted como electricista, deberá confirmar la solicitud para que inicie el proceso de la nueva cuenta.</p>

              <p>
                * Recuerde que tiene plazo hasta: <b>{this.state.solicitudSelected?.maxima_fecha_confirmacion}</b>
              </p>

              <p>* Si no realiza este proceso en el plazo establecido, la solicitud será cancelada de forma automática.</p>
            </div>

            <Button
              variant="contained"
              size="large"
              startIcon={<Icon>done</Icon>}
              style={{ margin: '10px', backgroundColor: '#4caf50', color: 'white' }}
              onClick={() => {
                this.confirmarSolicitud();
              }}
            >
              Confirmar
            </Button>

            <Button
              variant="contained"
              size="large"
              startIcon={<Icon>block</Icon>}
              style={{ margin: '10px', backgroundColor: '#e53935', color: 'white' }}
              onClick={() => {
                this.rechazarSolicitud();
              }}
            >
              Rechazar
            </Button>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default withRouter(CuentaNuevaList);
